/* eslint-disable @typescript-eslint/no-explicit-any */
import {
	Component,
	EventEmitter,
	Input,
	Output,
	TemplateRef,
	ViewChild
} from "@angular/core";
import {
	ControlContainer,
	ControlValueAccessor,
	UntypedFormControl,
	FormControlDirective,
	NG_VALUE_ACCESSOR
} from "@angular/forms";
import { TooltipPlacementType } from "./types";

@Component({
	selector: "app-checkbox",
	templateUrl: "./checkbox.component.html",
	styleUrls: ["./checkbox.component.scss"],
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: CheckboxComponent,
			multi: true
		}
	],
	standalone: false
})
export class CheckboxComponent implements ControlValueAccessor {
	@ViewChild(FormControlDirective, { static: true })
	formControlDirective!: FormControlDirective;

	@Input()
	formControlName = "";

	@Input()
	labelText = "";

	@Input()
	tooltipRef: string | TemplateRef<unknown> = "";

	@Input()
	tooltipPlacement: TooltipPlacementType = "top";

	@Output() changedValueFormControl = new EventEmitter<{
		formControlname: string;
		value: boolean;
	}>();

	constructor(private controlContainer: ControlContainer) {}

	get control(): UntypedFormControl | null {
		return this.controlContainer.control?.get(
			this.formControlName
		) as UntypedFormControl;
	}

	registerOnTouched(fn: any): void {
		this.formControlDirective?.valueAccessor?.registerOnTouched(fn);
	}

	registerOnChange(fn: any): void {
		this.formControlDirective?.valueAccessor?.registerOnChange(fn);
	}

	writeValue(obj: any): void {
		this.formControlDirective?.valueAccessor?.writeValue(obj);
	}

	setDisabledState(isDisabled: boolean): void {
		if (this.formControlDirective?.valueAccessor?.setDisabledState) {
			this.formControlDirective.valueAccessor.setDisabledState(
				isDisabled
			);
		}
	}

	onChangeValue(event: HTMLInputElement): void {
		this.changedValueFormControl.emit({
			formControlname: this.formControlName,
			value: event.checked
		});
	}
}
